export const TORCH_ASSETS_BANNER_PHASE = {
  parametrization: 'parametrization',
  deduplication: 'deduplication',
  discovery: 'discovery',
} as const;

export type TorchAssetsBannerPhase =
  (typeof TORCH_ASSETS_BANNER_PHASE)[keyof typeof TORCH_ASSETS_BANNER_PHASE];

export function resolveTorchAssetsBannerPhase({
  isDiscoveryActive,
  isParametrizationActive,
  isDeduplicationActive,
  isDeduplicationEnabled,
  assetTypeFilter,
  relevantProcessingAssetTypes,
}: {
  isDiscoveryActive: boolean;
  isParametrizationActive: boolean;
  isDeduplicationActive: boolean;
  isDeduplicationEnabled: boolean;
  assetTypeFilter?: string;
  relevantProcessingAssetTypes?: string[];
}): TorchAssetsBannerPhase | null {
  const isTypeRelevant =
    !relevantProcessingAssetTypes ||
    !assetTypeFilter ||
    relevantProcessingAssetTypes.includes(assetTypeFilter);

  if (isParametrizationActive && isTypeRelevant) {
    return TORCH_ASSETS_BANNER_PHASE.parametrization;
  }

  if (isDeduplicationEnabled && isDeduplicationActive && isTypeRelevant) {
    return TORCH_ASSETS_BANNER_PHASE.deduplication;
  }

  if (isDiscoveryActive) {
    return TORCH_ASSETS_BANNER_PHASE.discovery;
  }

  return null;
}
